import { createEntityAdapter } from '@reduxjs/toolkit'

import { DropdownState } from './models/DropdownState'

export const dropdownsAdapter = createEntityAdapter({
  selectId: (dd: DropdownState) => dd.name,
})
